import { useQuery } from "@apollo/client";

import { PlannerVisitWorkerReportByIdDocument, PlannerVisitWorkerReportByIdQuery } from "./usePlannerVisitWorkerReport.generated";

export type UsePlannerVisitWorkerReportShape = NonNullable<PlannerVisitWorkerReportByIdQuery["plannerVisitWorkerReportById"]>;

export function usePlannerVisitWorkerReport(reportId: string) {
    const { data, loading, error } = useQuery(PlannerVisitWorkerReportByIdDocument, {
        variables: { reportId },
    });

    return {
        loading,
        error,
        data: data?.plannerVisitWorkerReportById,
    };
}
